import React from 'react';
import '../../styles/StudentComponents/FeaturedClasses.css';
import learnersImage from '../../assets/Images/Group 232.webp'; 

const FeaturedClasses = () => {
    return (
      <section className="featured-section">
        <h2 className="featured-title">Featured academies & popular classes</h2>
        <div className="featured-layout">
  
          {/* Left: Card 1 */}
          <div className="card tall-card">
            <img src={learnersImage} alt="Learning Illustration" className="card-img" />
            <div className="card-content card-content1">
            <div className="card-header">
              <span className="card-number">01</span>
              <div className="card-title-answer first">
              <h3>Find the perfect learning experience tailored just for you</h3>
              <p>
                Discover instructors who see the unique potential in every learner and know exactly how to nurture it into remarkable skills that last a lifetime—whether you’re beginning your own journey or supporting someone else’s.
              </p>
              {/* <a href="#" className="card-link">Explore →</a> */}
              </div>
              </div>
            </div>
          </div>
  
          {/* Right: Card 2 + Card 3 */}
          <div className="right-column">
            <div className="card">
              <div className="card-content">
              <div className="card-header">
                <span className="card-number">02</span>
                <div className="card-title-answer">
                <h3>Join Our Community Of Learners And Expert Instructors Today</h3>
                <p>
                  Step into a supportive network where growth happens naturally alongside peers who share your interests, guided by mentors who remember what it’s like to discover something amazing for the first time.
                </p>
                {/* <a href="#" className="card-link">Join →</a> */}
                </div>
                </div>
              </div>
            </div>
  
            <div className="card">
              <div className="card-content">
              <div className="card-header">
                <span className="card-number">03</span>
                <div className="card-title-answer">
                <h3>Unlock your potential with our diverse range of courses</h3>
                <p>
                  From robotics to piano, creative writing to chess—explore possibilities that conventional education simply can’t provide. Find those special abilities that make you or your child uniquely brilliant in ways standardized testing never measures.
                </p>
                {/* <a href="#" className="card-link">Explore →</a> */}
                </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </section>
    );
  };
  
  export default FeaturedClasses;